<template>
  <NuxtLayout name="users">
    <div class="hk-pg-body py-0 gc-page">
      <div class="gc-layout">
        <GenerationContenusSidebar />
        <main class="gc-layout__content">
          <slot />
        </main>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
onMounted(() => {
  document.documentElement.classList.add("gc-layout-lock");
  document.body.classList.add("gc-layout-lock");
});

onBeforeUnmount(() => {
  document.documentElement.classList.remove("gc-layout-lock");
  document.body.classList.remove("gc-layout-lock");
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

/* Fixe sous le header (65px) + menu horizontal (65px) */
.gc-page {
  position: fixed;
  top: 130px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  background-color: #F9F9FB;
  font-family: $font_ai;
}

@media (max-width: 1199px) {
  .gc-page {
    top: 65px;
  }
}

.gc-layout {
  display: flex;
  height: 100%;
  overflow: hidden;

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 24px;
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

html.gc-layout-lock,
body.gc-layout-lock {
  overflow: hidden !important;
  height: 100%;
}

/* Plus Jakarta Sans — design system (modales téléportées incluses) */
.gc-page [class*="ds-"],
body.gc-layout-lock [class*="ds-"] {
  font-family: $font_ai !important;
}
</style>
